import { getUrlParam } from './helpers';

let isValid = false;
let gaId: string | null = null;

export const initTealium = () => {
    const gl = getUrlParam('_gl');
    isValid = validateGLTag(gl);
    if (isValid) {
        const glArray = gl.split('*');
        gaId = atob(glArray[3]);
    }
};

const validateGLTag = (gl: string) => {
    try {
        const glArray = gl.split('*');
        const chksums = [-2, -1, 0, 1, 2].map((tolerance) => {
            return generateChecksum(glArray[3], tolerance);
        });
        const validChksum = chksums.indexOf(glArray[1]) >= 0;
        return validChksum;
    } catch (error) {
        return false;
    }
};

// Based on the following
// https://github.com/ampproject/amphtml/blob/main/extensions/amp-analytics/linker-id-receiving.md
const generateChecksum = (id: string, tolerance: number) => {
    const date = new Date();
    const language = navigator.language;
    const ua = navigator.userAgent;
    const tz = date.getTimezoneOffset();
    const fingerprint = `${ua}*${tz}*${language}`;
    const ts = Math.floor(Date.now() / 60000) + tolerance;
    const ids = `_ga*${id}`;
    const chk = `${fingerprint}*${ts}*${ids}`;
    const chksum = crc32(chk).toString(36);
    return chksum;
};

// FIXME: Function is only a placeholder, it will need to be updated
export const logTealiumEvent = async () => {
    if (!isValid) {
        return;
    }

    const data = {
        tealium_account: 'providence',
        tealium_profile: 'main',
        data_source: 'fyy21o',
        tealium_event: 'chatbot_initiate_chat',
        event_category: 'Chatbot Interactions',
        event_action: 'Initiate Interaction - Terms Agreement',
        event_label: 'I Agree',
        chatbot_version: 'ExpressCare',
        ga_id: gaId,
    };

    await fetch('https://collect.tealiumiq.com/event', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });
};

// Much of this logic for validating checksums pulled from the following
// https://github.com/ampproject/amphtml/blob/main/extensions/amp-analytics/0.1/crc32.js
const CRC32_KEY = 0xedb88320;
let crcTable: any[] | null = null;

function utf8Encode(string: string) {
    if (typeof TextEncoder !== 'undefined') {
        return new (TextEncoder as any)('utf-8').encode(string);
    }
    return stringToBytes(unescape(encodeURIComponent(string)));
}

function stringToBytes(str: string) {
    const bytes = new Uint8Array(str.length);
    for (let i = 0; i < str.length; i++) {
        const charCode = str.charCodeAt(i);
        bytes[i] = charCode;
    }
    return bytes;
}

function crc32(str: string) {
    if (!crcTable) {
        crcTable = makeCrcTable();
    }

    const bytes = utf8Encode(str);

    // Shrink to 32 bits.
    let crc = -1 >>> 0;
    for (let i = 0; i < bytes.length; i++) {
        const lookupIndex = (crc ^ bytes[i]) & 0xff;
        crc = (crc >>> 8) ^ crcTable[lookupIndex];
    }
    return (crc ^ -1) >>> 0;
}

function makeCrcTable() {
    const crcTable = new Array(256);
    for (let i = 0; i < 256; i++) {
        let c = i;
        for (let j = 0; j < 8; j++) {
            if (c & 1) {
                c = (c >>> 1) ^ CRC32_KEY;
            } else {
                c = c >>> 1;
            }
        }
        crcTable[i] = c;
    }
    return crcTable;
}
